import BarChartIcon from '@mui/icons-material/BarChart'
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import { Box, Tab, Tabs } from '@mui/material'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { useThemeMode } from '../../../theme'
import { getEntitlements } from '../../../utils'

const makeStyles = (palette) => ({
  container: {
    position: 'sticky',
    zIndex: 100,
    height: '50px',
    top: 0
  },
  tabs: {
    background: palette.headerTransparentColor,
    height: '50px',
    '& .Mui-selected': {
      color: `${palette.paperColor} !important`
    },
    '@media (max-width: 350px)': {
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important'
    }
  }
})

export const SnacksMenu = () => {
  const { pathname } = useLocation()
  const { palette } = useThemeMode()
  const auth = useSelector((state) => state.auth)
  const isAdmin = getEntitlements(auth?.accessToken).includes('AdminCesfurSnacks:full')
  const sx = makeStyles(palette)

  let tabValue = 0
  if (pathname === '/voting/snacks/my-table') tabValue = 1
  else if (pathname === '/voting/snacks/results') tabValue = 2

  return (
    <Box sx={sx.container}>
      <Tabs
        aria-label="snacks menu tabs"
        value={isAdmin ? tabValue : Math.min(tabValue, 1)}
        TabIndicatorProps={{ style: { backgroundColor: palette.headerColor } }}
        sx={sx.tabs}
      >
        <Tab component={Link} to="/voting/snacks" icon={<ListAltOutlinedIcon />} aria-label="All tables" />
        <Tab component={Link} to="/voting/snacks/my-table" icon={<PersonOutlineIcon />} aria-label="My table" />
        {isAdmin && (
          <Tab component={Link} to="/voting/snacks/results" icon={<BarChartIcon />} aria-label="Results" />
        )}
      </Tabs>
    </Box>
  )
}
